export default __webpack_public_path__ + "static/media/endingScreen.5c0800d5.png";